export { default } from './SubheaderSpan';